import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useLocation } from "react-router-dom";
import axios from "axios";

import CourseInnerContent from "../Components/CourseInnerContent";
import LecturePage from "../Components/LecturePage";
import MoreInfoPage from "./MoreInfoPage";
import QuizPage from "./QuizPage";

function CourseContent(props) {
  const location = useLocation();
  const locState = location?.state ?? null;
  const courseID = locState?.courseID ?? props.courseID ?? "";
  const myCourseName = (locState?.myCourseName ?? "").trim();

  const [courseContentInfo, setCourseContentInfo] = useState(null);
  const [lastTestId, setLastTestId] = useState(null);
  const [courseInforType, setCourseInforType] = useState(null);
  const [lectureInfoId, setLectureInfoId] = useState(null);
  const [resetContent, setResetContent] = useState(0);
  const [index, setIndex] = useState(0);
  const [marylandDocument, setMarylandDocument] = useState("");
  // const [lectureVideoTime, setLectureVideoTime] = useState(0);

  const [, setComponentReload] = useState(0);
  const [resetMenu, setResetMenu] = useState(0);

  const courseItems = courseContentInfo?.filter((item) => item.type !== "link") || [];
  const courseLinks = courseContentInfo?.filter((item) => item.type === "link") || [];

  const returnCourseContent = (type, courseId) => {
    // console.log("Video Time is:");
    setComponentReload(new Date().getTime());
    if (type === courseInforType) {
      setCourseInforType(type);
      setResetContent(resetContent + 1);
    } else {
      setCourseInforType(type);
    }
    setLectureInfoId(courseId);
  };

  // Mobile Navigation Back Button
  const PrevCourse = () => {
    if (courseItems.length) {
      if (lectureInfoId) {
        const currentIndex = courseItems.findIndex(
          (lecture) => lecture.id === lectureInfoId
        );

        if (0 <= currentIndex - 1) {
          setCourseInforType(courseItems[currentIndex - 1].type);
          setLectureInfoId(courseItems[currentIndex - 1].id);
          setIndex(currentIndex - 1);
        } else {
          return;
        }
      } else {
        setCourseInforType(courseItems[0].type);
        setLectureInfoId(courseItems[0].id);
        setIndex(0);
      }

      setResetContent(resetContent + 1);
    } else {
      return;
    }
  };

  // Mobile Navigation Forward Button
  const NextCourse = () => {
    if (courseItems.length) {
      if (lectureInfoId) {
        const currentIndex = courseItems.findIndex(
          (lecture) => lecture.id === lectureInfoId
        );

        if (currentIndex + 1 <= courseItems.length - 1) {
          setCourseInforType(courseItems[currentIndex + 1].type);
          setLectureInfoId(courseItems[currentIndex + 1].id);
          setIndex(currentIndex + 1);
        } else {
          return;
        }
      } else {
        setCourseInforType(courseItems[0].type);
        setLectureInfoId(courseItems[0].id);
        setIndex(0);
      }

      setResetContent(resetContent + 1);
    } else {
      return;
    }
  };

  // Calculate how many components should be unlocked so progress is linear
  const [completionMap, setCompletionMap] = useState({});
  const handleCompletionUpdate = React.useCallback((lectureId, isFinished) => {
    setCompletionMap(prev => {
      if (prev[lectureId] === isFinished) return prev;
      return { ...prev, [lectureId]: isFinished };
    });
  }, []);
  const maxUnlockedIndex = Object.values(completionMap).filter(Boolean).length + 1;
  // Calculate if can use mobile nav tools too
  const isWelcomePage = !lectureInfoId;
  const nextUnlock = isWelcomePage ? true : index < maxUnlockedIndex -1;

  useEffect(() => {
    if (!courseID) return;

    axios.post("/extractCourseContent", { courseId: courseID }).then((data) => {
      const content = data.data;
      setCourseContentInfo(content);
      if (Array.isArray(content) && content.length > 0) {
        const testItems = content.filter((item) => item.type === "test");
        if (testItems.length > 0) {
          const lastTest = testItems[testItems.length - 1];
          setLastTestId(lastTest.id);
        }
      }
    });

    axios.get("/extractMarylandDoc").then((data) => {
      setMarylandDocument(data.data);
    });
  }, [courseID]);

  return (
    <Container>
      <CourseMenuContainer>
        {courseItems.map((item, index) => {
          const isUnlocked = index < maxUnlockedIndex;

          return (
            <CourseCheckboxContainer
              key={item.id}
              $isUnlocked={isUnlocked}
              onClick={
                isUnlocked
                  ? () => returnCourseContent(item.type, item.id)
                  : undefined
              }
              style={{
                cursor: isUnlocked ? "pointer" : "",
                opacity: isUnlocked ? 1 : 0.35,
              }}
            >
              <CourseInnerContent
                lectureId={item.id}
                courseId={courseID}
                refreshKey={resetMenu}
                onCompletionChange={handleCompletionUpdate}
              />

              {item.title}
            </CourseCheckboxContainer>
          );
        })}
        {courseLinks.length > 0 && (
          <ResourceSection>
            {courseLinks.map((item) => (
              <CourseLink
                key={item.id}
                href={item.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                ↗ {item.title}
              </CourseLink>
            ))}
          </ResourceSection>
        )}
      </CourseMenuContainer>
      <CourseContentContainer>
        <NavigationBar>
          <NavLeft onClick={() => PrevCourse()}>
            ‹
          </NavLeft>
          <Progress>
            <ProgressComplete
              style={{
                width: `${
                  index >= 1
                    ? `${100 * (index / (courseItems.length - 1))}%`
                    : "10px"
                }`,
              }}
            />
          </Progress>
          <NavRight
            onClick={nextUnlock ? () => NextCourse() : undefined}
            style={{
              cursor: nextUnlock ? "pointer" : "not-allowed",
              opacity: nextUnlock ? 1 : 0.3,
            }}
          >
            ›
          </NavRight>
        </NavigationBar>
        {courseInforType 
          ? ( courseInforType === "video"
            ? ( lectureInfoId 
              ? (
                <LecturePage
                  lectureId={lectureInfoId}
                  courseId={courseID}
                  menuReload={(val) => setResetMenu(val)}
                  key={resetContent}
                />
              ) : (
                <WelcomePage>Welcome</WelcomePage>
              )
            ) : courseInforType === "text" 
              ? (
                <MoreInfoPage
                  lectureId={lectureInfoId}
                  courseId={courseID}
                  key={resetContent}>
                  Some more info
                </MoreInfoPage>
              ) : (
                <QuizPage
                  lectureId={lectureInfoId}
                  courseId={courseID}
                  lastTestId={lastTestId}
                  menuReload={(val) => setResetMenu(val)}
                  key={resetContent}>
                  The quiz page
                </QuizPage>
              )
          ) : (
            <WelcomePage>
              <WelcomeContent>Welcome</WelcomeContent>
              {(myCourseName === "Maryland Petroleum Class C Dispenser" || myCourseName === "Maryland Petroleum Class C Generator") ??
                <DocumentContainer>
                  <a href={marylandDocument} target="_blank" rel="noreferrer">
                    Class C Operator Training Checklist and Certification
                  </a>
                </DocumentContainer>
              }
            </WelcomePage>
          )}
      </CourseContentContainer>
    </Container>
  );
}

export default CourseContent;

const Container = styled.div`
  padding: 70px 0px 0px 0px;
  display: grid;
  grid-template-columns: 200px auto;
  height: 100%;
  overflow: auto;
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;
const CourseCheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;

  transition: color 0.3s ease;

  ${({ $isUnlocked }) =>
    $isUnlocked &&
    `
      &:hover {
        color: #007BFF;
      }
    `
  }
`;
const NavigationBar = styled.div`
  width: 80%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: #8B8B8B;
  font-weight: 700;
  font-size: 1.5rem;
  margin: 10px auto 20px auto;

  @media(min-width: 768px) {
    display: none;
  }
`;

const NavLeft = styled.div`
  height: 40px;
  width:  40px;
  margin-right: 10px;
  border: 3px solid #8B8B8B;
  border-radius: 50%;
  background-color: #BDBDBD;
  cursor: pointer;
`;
const Progress = styled.div`
  height: 20px;
  width: 80%;
  display: flex;
  align-items: center;
  text-align: center;
  border: 3px solid #8B8B8B;
  border-radius: 10px;
`;
const ProgressComplete = styled.div`
  height: 10px;
  margin: 0px 3px;
  justify-content: left;
  align-items: left;
  border: 3px solid #8B8B8B;
  background-color: #8B8B8B;
  border-radius: 5px; 
  transition: width 0.6s ease, background-color 0.3s ease;
`;

const NavRight = styled.div`
  height: 40px;
  width:  40px;
  margin-left: 10px;
  border: 3px solid #8B8B8B;
  border-radius: 50%;
  background-color: #BDBDBD;
  cursor: pointer;
`;

const CourseMenuContainer = styled.div`
  border-right: 1px solid black;
  padding-top: 20px;
  padding-left: 20px;

  @media (max-width: 768px) {
    display: none;
  }
`;
const CourseContentContainer = styled.div`
  padding: 20px;
`;

const ResourceSection = styled.div`
  border-top: 1px solid #bfbfbf;
  margin-top: 10px;
  padding-top: 10px;
  padding-right: 10px;
`;

const CourseLink = styled.a`
  display: block;
  color: black;
  text-decoration: none;
  margin-bottom: 10px;
  cursor: pointer;

  transition: color 0.3s ease;

  &:hover {
    color: #007bff;
    text-decoration: underline;
  }
`;

const WelcomePage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  flex-direction: column;
  @media (max-width: 768px){
    flex-direction: none;
    width: 100%;
  }
`;

const DocumentContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 10px;
`;

const WelcomeContent = styled.div`
  font-size: 20px;
  font-weight: 700;
`;
